import { apiClient } from '@/config/api';
import { AreaType, HydraCollection } from '@/types';

export const areaTypeService = {
  // Get all area types
  async getAreaTypes(): Promise<AreaType[]> {
    const response = await apiClient.get<HydraCollection<AreaType>>('/area_types', {
      params: {
        'groups[]': ['areaType:read'],
      },
    });

    const data = response.data;
    const areaTypes = data['hydra:member'] || data['member'] || [];
    return areaTypes;
  },
};
